import React from "react";
import {Layout} from "antd";
import Header from "../components/headerComponent/header";
import Footer from "../components/footerComponent/footer";
import AddPercent from "../components/financeComponent/addPercentComponent";

export default function AddPercentPage() {
    return (
        <Layout>
            <Header/>
            <AddPercent/>
            <Footer/>
        </Layout>
    );
}